<div class="pauly-checkbox-container">
  <mat-checkbox
    class="checkbox checkbox-bg"
    [checked]="checked"
    [disabled]="isDisabled"
    (change)="onCheckboxChange($event.checked)"
  >
    <span>
      {{ label }}
    </span>
    @if (info) {
      <span
        class="info-icon ml-2 dashboard-tooltip checkbox-tooltip"
        matTooltipClass="dig-tooltip"
        #tooltip="matTooltip"
        [matTooltip]="info"
        (click)="$event.preventDefault(); tooltip.toggle()"
      >
        <span [inlineSVG]="'/icons/icon-info-circle-v2.svg'"></span>
      </span>
    }
  </mat-checkbox>
</div>
